<template>
    <div class="cl-radio-button" :style="{background,'border-radius':radius,border, padding}">
        <el-radio-group
            v-model="radioTab"
            size="medium"
            style="width:100%;"
            v-bind="$attrs"
            v-on="$listeners"
        >
            <el-radio-button
                :label="item.key"
                v-for="item in option"
                :key="item.key"
                :style="{
                    'width': radioWidth,
                    fontSize,
                    'border-radius': radioRadius,
                    'boxShadow': radioTab==item.key ? boxShadow : '' ,
                    'background-color':radioBackground
                }"
                @change="change(item)"
            >{{ item['value'+$lang] || item.value }}</el-radio-button>
        </el-radio-group>
    </div>
</template>

<script>

export default {
    name: 'cl-radio-button',
    props: {
        value: {
            type: String,
            default: () => ''
        },
        option: {
            type: Array,
            default: () => []
        },
        // 外层盒子
        padding: {
            type: [String, Number],
            default: () => ''
        },
        width: {
            type: String,
            default: () => ''
        },
        border: {
            type: String,
            default: () => ''
        },
        radius: {
            type: String,
            default: () => ''
        },
        background: {
            type: String,
            default: () => ''
        },
        // 内层
        radioWidth: {
            type: String,
            default: () => ''
        },
        radioRadius: {
            type: String,
            default: () => '6px'
        },
        fontSize: {
            type: String,
            default: () => '14px'
        },
        boxShadow: {
            type: String,
            default: () => ''
        },
        radioBackground: {
            type: String,
            default: () => '#fff'
        },
    },
    data () {
        return {
            radioTab: this.value,
        }
    },
    methods: {
        change (item) {
            this.$emit('change', this.radioTab, item)
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },

}
</script>
<style lang="scss" scoped>
.cl-radio-button {
    box-sizing: border-box;
    background-color: #f3f3f3;
    border-radius: 6px;
    padding: 5px;
}
// el-radio-button
/deep/.el-radio-button__inner {
    border: none !important;
    color: $base-font-minor;
    width: 100%;
    font-size: inherit !important;
    background-color: transparent;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-radius: inherit !important;
}
/deep/.el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
    box-shadow: none;
}
</style>
